import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { MatTableDataSource } from '@angular/material/table';
import {
  GlobalConstantsRegex,
  GlobalConstantsRouting,
  GlobalConstantsSonstige,
  GlobalFunctionsGui,
  GlobalService,
  InputErrorStateMatcher,
  ValueFormat,
} from 'globales-projekt-angular';
import { WindRichtlinienab } from 'src/app/data/ws/wind-richtlinienab.model';
import { FormControl, Validators } from '@angular/forms';
import { ErgebnisQuelleGes } from 'src/app/data/ws/ergebnis-quelle-ges.model';
import { LocalService } from 'src/app/services/local.service';
//import { Router } from '@angular/router';
import { SpinnerService } from 'src/app/components/elemente/mat-spinner-overlay/service/spinner.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ModalWindrichtungWertAnzeigenComponent } from '../modal/modal-windrichtung-wert-anzeigen/modal-windrichtung-wert-anzeigen.component';
import { TabsMain } from 'src/app/immutable/enums/tabs-main';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css'],
})
export class MainComponent implements OnInit {
  showWaitingForDataSpinner: number = 0;
  showReset: boolean = false;

  fileName: string;

  tooltipPosition = new FormControl(GlobalConstantsSonstige.POSITION_OPTIONS[0]);

  selectedTabIndex: number = 0;

  formControlGanzZahlLaeng4OderKomma2NumberWarning: string = GlobalConstantsRegex.getRegexTextBuilderZahl(GlobalConstantsRegex.GANZ_ZAHL_LAENG_4_ODER_KOMMA_2_TEXT);
  formControlGanzZahlLaeng4OderKomma1NumberWarning: string = GlobalConstantsRegex.getRegexTextBuilderZahl(GlobalConstantsRegex.GANZ_ZAHL_LAENG_4_ODER_KOMMA_1_TEXT);
  formControlGanzZahlLaeng2OderKomma2NumberWarning: string = GlobalConstantsRegex.getRegexTextBuilderZahl(GlobalConstantsRegex.GANZ_ZAHL_LAENG_2_ODER_KOMMA_2_TEXT);
  formControlGanzZahlLaeng2NumberWarning: string = GlobalConstantsRegex.getRegexTextBuilderZahl(GlobalConstantsRegex.GANZ_ZAHL_LAENG_2_TEXT);

  public bezeichnungFormControl: FormControl = new FormControl(
    null,
    Validators.required
  );
  public beschreibungFormControl: FormControl = new FormControl(null);


  matcher: InputErrorStateMatcher = new InputErrorStateMatcher();


  dataWindRichtlinienabList: MatTableDataSource<WindRichtlinienab> =
    new MatTableDataSource();

  public windhaeufigkeitSumme: string;

  ergebnisQuelleGes: ErgebnisQuelleGes = new ErgebnisQuelleGes();


  isDisabled: boolean = true;

  valueFormat: ValueFormat = new ValueFormat();

  constructor(
    private apiService: ApiService,
    private router: Router,
    private localService: LocalService,
    private globalService: GlobalService,
    private spinnerService: SpinnerService,
    private dialog: MatDialog
  ) {
    this.localService.mainComponentRef.next(this);

    this.windhaeufigkeitSumme = this.valueFormat.getStringDecimal(0, 0);

    this.bezeichnungFormControl.valueChanges.subscribe(value => {
      this.localService.updateBezeichnung(value ?? null);
      this.checkAndSetButtonState();
    });

    this.beschreibungFormControl.valueChanges.subscribe((value) => {
      this.localService.updateBeschreibung(value ?? null);
      this.checkAndSetButtonState();
    });

    this.bezeichnungFormControl.setValue(this.localService.aktuellerUserBetrieb.value.bezeichnung);
    this.beschreibungFormControl.setValue(this.localService.aktuellerUserBetrieb.value.beschreibung);
  }

  async ngOnInit(): Promise<void> {
    this.getTierarten();
    this.getTierkategorien();
    this.getMinderungsmassnahmenTierkategorien();
    this.getMinderungsmassnahmenFlaechen();
    this.getTkHvGeruchsemissionen();
    this.getGebietskategorien();
    this.getFlaechenquellarten();
  }

  loadUserDatenEingabe() {
  }

  getTierarten() {
    this.localService.mainComponentRef.value?.waitingForDataSpinner(true);
    this.apiService.getTierarten().subscribe((response) => {
      this.localService.tierartList.next(response);
      this.loadUserDatenEingabe();
      this.localService.mainComponentRef.value?.waitingForDataSpinner(false);
    });
  }

  getTierkategorien() {
    this.localService.mainComponentRef.value?.waitingForDataSpinner(true);
    this.apiService.getTierkategorien().subscribe((response) => {
      this.localService.tierkategorieList.next(response);
      this.loadUserDatenEingabe();
      this.localService.mainComponentRef.value?.waitingForDataSpinner(false);
    });
  }

  getMinderungsmassnahmenTierkategorien() {
    this.localService.mainComponentRef.value?.waitingForDataSpinner(true);
    this.apiService
      .getMinderungsmassnahmenTierkategorien()
      .subscribe((response) => {
        this.localService.minderungsmassnahmeTierkategorieList.next(response);
        this.localService.mainComponentRef.value?.waitingForDataSpinner(false);
      });
  }

  getMinderungsmassnahmenFlaechen() {
    this.localService.mainComponentRef.value?.waitingForDataSpinner(true);
    this.apiService.getMinderungsmassnahmenFlaechen().subscribe((response) => {
      this.localService.minderungsmassnahmeFlaechenList.next(response);
      this.localService.mainComponentRef.value?.waitingForDataSpinner(false);
    });
  }

  getTkHvGeruchsemissionen() {
    this.localService.mainComponentRef.value?.waitingForDataSpinner(true);
    this.apiService.getTkHvGeruchsemissionen().subscribe((response) => {
      this.localService.tkHvGeruchsemissionList.next(response);
      this.loadUserDatenEingabe();
      this.localService.mainComponentRef.value?.waitingForDataSpinner(false);
    });
  }

  getGebietskategorien() {
    this.localService.mainComponentRef.value?.waitingForDataSpinner(true);
    this.apiService.getGebietskategorien().subscribe((response) => {
      this.localService.globalWSData.next(response);
      this.localService.mainComponentRef.value?.waitingForDataSpinner(false);
    });
  }

  getFlaechenquellarten() {
    this.localService.mainComponentRef.value?.waitingForDataSpinner(true);
    this.apiService.getFlaechenquellarten().subscribe((response) => {
      this.localService.flaechenquellartList.next(response);
      this.localService.mainComponentRef.value?.waitingForDataSpinner(false);
    });
  }



  onClickZuErgebnisse() {
    const dialogRef = this.dialog.open(ModalWindrichtungWertAnzeigenComponent, {
      autoFocus: false,
      width: GlobalConstantsSonstige.BREITE_MODAL_KLEIN,
      maxWidth: GlobalConstantsSonstige.BREITE_MODAL_KLEIN,
      disableClose: true,
      panelClass: GlobalConstantsSonstige.KTBL_DIALOG_NO_SCROLLBALKEN
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result == 1) {

        this.localService.mainComponentRef.value?.waitingForDataSpinner(true);


        this.apiService
          .postErgebnisBetrieb(this.localService.aktuellerUserBetrieb.value)
          .subscribe((response) => {
            this.localService.ergebnisBetrieb.next(response);

            this.router.navigate([GlobalConstantsRouting.ERGEBNISSE]);
            this.localService.mainComponentRef.value?.waitingForDataSpinner(false);
          });
      }
      else if (result == 2) {
        this.selectedTabIndex = TabsMain.WINDDATEN;
      }

    });

  }

  checkAndSetButtonState() {
    this.isDisabled = false;
    this.isDisabled = this.isDisabled || !this.bezeichnungFormControl.valid;
    this.isDisabled = this.isDisabled || !this.localService.betriebComponentRef.value?.getIsValid();
    this.isDisabled = this.isDisabled || !this.localService.winddatenGebietskategorieComponentRef.value?.getIsValid();
 
    this.localService.isBetriebValid.next(!this.isDisabled);
  }

  onClickEntfernenInputs() {
    if (this.selectedTabIndex === TabsMain.QUELLEN) {
      this.localService.betriebComponentRef.value?.entfernenInputs();
      this.ergebnisQuelleGes = new ErgebnisQuelleGes();

    }
    else if (this.selectedTabIndex === TabsMain.WINDDATEN) {
      this.localService.winddatenGebietskategorieComponentRef.value?.entfernenInputs();
    }






    /*
    
        this.bezeichnungFormControl.setValue(null);
        this.beschreibungFormControl.setValue(null);
    */


    this.checkAndSetButtonState();
  }

  public waitingForDataSpinner(wait: boolean) {
    if (wait) this.spinnerService.show();
    else this.spinnerService.hide();

    this.globalService.isShowSpinner.next(this.spinnerService.getCountSpinner() != 0);
  }

  onClickUp() {
    GlobalFunctionsGui.clickUp();
  }

  onClickDown() {
    GlobalFunctionsGui.clickDown();
  }
}
